"use client";

import React, { useState, FormEvent } from "react";
import Image from "next/image";

const ContactSection: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    msg_subject: "",
    message: "",
  });

  const [submitMessage, setSubmitMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Here you can add your API call or form submission logic
    setSubmitMessage("Your message has been sent successfully!");
    setFormData({
      name: "",
      email: "",
      phone_number: "",
      msg_subject: "",
      message: "",
    });
  };

  return (
    <section className="home-contact-area pb-100 pt-100">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-6 ps-0">
            <div className="contact-img">
              <Image src="/images/contact.png" alt="contact" width={600} height={400} />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="home-contact-content">
              <h2>What Do You Want to Know?</h2>
              <form id="contactForm" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control"
                        required
                        placeholder="Your Name"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control"
                        required
                        placeholder="Your Email"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleChange}
                        className="form-control"
                        required
                        placeholder="Your Phone"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="msg_subject"
                        value={formData.msg_subject}
                        onChange={handleChange}
                        className="form-control"
                        required
                        placeholder="Your Subject"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="form-control"
                        cols={30}
                        rows={5}
                        required
                        placeholder="Your Message"
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <button type="submit" className="default-btn page-btn box-btn">
                      Send Message
                    </button>
                    {submitMessage && <div className="h3 text-center mt-3">{submitMessage}</div>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
